export enum SpecRequestTypes {
  ListSpecsRequest = 'spec/LIST_SPECS_REQUEST',
  ListSpecsSuccess = 'spec/LIST_SPECS_SUCCESS',
  ListSpecsFailure = 'spec/LIST_SPECS_FAILURE',
  ListSpecConfigsRequest = 'spec/LIST_SPEC_CONFIGS_REQUEST',
  ListSpecConfigsSuccess = 'spec/LIST_SPEC_CONFIGS_SUCCESS',
  ListSpecConfigsFailure = 'spec/LIST_SPEC_CONFIGS_FAILURE',
  ListSpecMappingsRequest = 'spec/LIST_SPEC_MAPPINGS_REQUEST',
  ListSpecMappingsSuccess = 'spec/LIST_SPEC_MAPPINGS_SUCCESS',
  ListSpecMappingsFailure = 'spec/LIST_SPEC_MAPPINGS_FAILURE',
  ListSpecObjectConfigsRequest = 'spec/LIST_SPEC_OBJECT_CONFIGS_REQUEST',
  ListSpecObjectConfigsSuccess = 'spec/LIST_SPEC_OBJECT_CONFIGS_SUCCESS',
  ListSpecObjectConfigsFailure = 'spec/LIST_SPEC_OBJECT_CONFIGS_FAILURE',
  UpdateSpecMappingsRequest = 'spec/UPDATE_SPEC_MAPPINGS_REQUEST',
  UpdateSpecMappingsSuccess = 'spec/UPDATE_SPEC_MAPPINGS_SUCCESS',
  UpdateSpecMappingsFailure = 'spec/UPDATE_SPEC_MAPPINGS_FAILURE',
  BatchUpdateSpecMappingsRequest = 'spec/BATCH_UPDATE_SPEC_MAPPINGS_REQUEST',
  BatchUpdateSpecMappingsSuccess = 'spec/BATCH_UPDATE_SPEC_MAPPINGS_SUCCESS',
  BatchUpdateSpecMappingsFailure = 'spec/BATCH_UPDATE_SPEC_MAPPINGS_FAILURE',
  DeleteSpecMappingsRequest = 'spec/DELETE_SPEC_MAPPINGS_REQUEST',
  DeleteSpecMappingsSuccess = 'spec/DELETE_SPEC_MAPPINGS_SUCCESS',
  DeleteSpecMappingsFailure = 'spec/DELETE_SPEC_MAPPINGS_FAILURE',
  BatchDeleteSpecObjectMappingsRequest = 'spec/BATCH_DELETE_SPEC_MAPPINGS_REQUEST',
  BatchDeleteSpecObjectMappingsSuccess = 'spec/BATCH_DELETE_SPEC_MAPPINGS_SUCCESS',
  BatchDeleteSpecObjectMappingsFailure = 'spec/BATCH_DELETE_SPEC_MAPPINGS_FAILURE',
  UpdateSpecObjectConfigRequest = 'spec/UPDATE_SPEC_OBJECT_CONFIG_REQUEST',
  UpdateSpecObjectConfigSuccess = 'spec/UPDATE_SPEC_OBJECT_CONFIG_SUCCESS',
  UpdateSpecObjectConfigFailure = 'spec/UPDATE_SPEC_OBJECT_CONFIG_FAILURE',
  UpdateSpecConfigRequest = 'spec/UPDATE_SPEC_CONFIG_REQUEST',
  UpdateSpecConfigSuccess = 'spec/UPDATE_SPEC_CONFIG_SUCCESS',
  UpdateSpecConfigFailure = 'spec/UPDATE_SPEC_CONFIG_FAILURE',
}
